import React from 'react';
import { motion } from 'framer-motion';

const ToolCard = ({ 
  tool, 
  onClick, 
  isLoading = false, 
  children = null,
  className = ""
}) => {
  const handleClick = () => {
    if (onClick && !isLoading) {
      onClick(tool);
    }
  };

  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      className={`bg-white dark:bg-gray-800 p-6 rounded-2xl shadow-lg dark:shadow-gray-900/20 hover:shadow-xl dark:hover:shadow-gray-900/20 transition-all duration-200 ${className}`}
    >
      <div className="flex items-center mb-4">
        <tool.icon className="h-6 w-6 text-indigo-600 mr-3" />
        <h4 className="text-lg font-semibold">{tool.label}</h4>
      </div>
      
      <p className="text-gray-600 mb-4">{tool.description}</p>
      
      {children || (
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          disabled={isLoading}
          onClick={handleClick}
          className={`w-full py-3 px-5 rounded-xl font-medium text-white shadow-md dark:shadow-gray-900/20
            ${isLoading
              ? 'bg-gray-400'
              : 'bg-gradient-to-r from-indigo-500 to-indigo-600'}
            hover:shadow-lg dark:hover:shadow-gray-900/20 transition-all duration-200 flex justify-center items-center`}
        >
          {isLoading ? (
            <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          ) : (
            <>
              <tool.icon className="h-5 w-5 mr-2" />
              {tool.action || 'Test'}
            </>
          )}
        </motion.button>
      )}
    </motion.div>
  );
};

export default ToolCard;
